const indicatorProducts = [
  {
    id: 1,
    name: "Digital Indicator Panel",
    description: "4-digit LED display, 4-20mA / 0-10V input with configurable alarm.",
    image: "/assets/sensors/DI.png",
    price: "Request Quote"
  },
  {
    id: 2,
    name: "LED Signal Tower",
    description: "Multi-colour signal tower for machine status indication.",
    image: "/assets/sensors/led.png",
    price: "Request Quote"
  },
  {
    id: 3,
    name: "Relay Output Indicator",
    description: "Compact indicator module with relay output and status LED.",
    image: "/assets/sensors/relay.png",
    price: "Request Quote"
  },
  {
    id: 4,
    name: "Loop-Powered Indicator",
    description: "2-wire loop-powered indicator for 4-20mA loops, compact size.",
    image: "/assets/sensors/loop.png",
    price: "Request Quote"
  },
  {
    id: 5,
    name: "Tank Level Indicator",
    description: "Panel-mounted level indicator for tanks, easy mounting.",
    image: "/assets/sensors/tank.png",
    price: "Request Quote"
  }
];

export default indicatorProducts;
